<template>
  <div
    v-loading="{ active: billingStore.billingInfoLoading, backgroundColor: 'transparent' }"
    class="plans__body"
  >
    <div class="plans__body__plan-usage">
      <template v-if="canManageCustomer">
        <ProductsV3
          v-if="billingStore.billingInfo"
          class="plans__body__content"
        />
        <PaymentIssues class="plans__body__content" />
      </template>
      <NoAccessToCustomer v-else />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue'

import { useAuth } from '@/modules/Auth/useAuth'

import NoAccessToCustomer from './CBBNoAccessToCustomer.vue'
import PaymentIssues from './CBBPaymentIssues.vue'
import ProductsV3 from './CBBMain.vue'
import { useBillingInfoLoader } from './useBillingInfoLoader'
import { useTeamStore } from '@/pinia/useTeamStore'
import { useBillingStore } from './useBillingStore'

defineProps<{ title: string }>()

const { isAuthorized } = useAuth()

const billingInfoLoader = useBillingInfoLoader()
const billingStore = useBillingStore()
const canManageCustomer = computed(() => isAuthorized('manage_customer'))

const teamStore = useTeamStore()

onMounted(() => {
  if (!teamStore.currentTeam) {
    return
  }

  billingInfoLoader.load(teamStore.currentTeam.id)
})
</script>

<style lang="scss" scoped>
.plans__body {
  flex: 1 1 auto;
  overflow: visible auto;

  &__content {
    &:not(:last-child) {
      margin-bottom: 50px;
    }
  }
}
</style>
